<template>
  <SelectAjax
    v-if="editionMode"
    :value="modelValue"
    :value-object="selected"
    :label="label"
    :required="required"
    :url="url"
    :track-by="trackBy"
    :attribute-label="attributeLabel"
    :name="name"
    :errors="cErrors"
    @update:value-object="onSelect"
  />
  <BaseShowLabel v-else :label="label" :model-value="cDisplayedValue" />
</template>

<script>
import SelectAjax from '@c/SelectAjaxComponent/component/SelectAjax.vue'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'

import { fieldErrors } from './fieldErrors'

/**
 * Former package's ajax select: searches `url?terms=…`, starts from the
 * `defaultAjax` object and emits the selected id (or the whole object with
 * `fullModelResponse`), plus `workSelect`/`selected:value`.
 */
export default {
  name: 'BaseShowEditSelectAjax',
  components: { SelectAjax, BaseShowLabel },
  props: {
    editionMode: { type: Boolean, required: true },
    modelValue: {
      type: [Number, String, Object],
      required: false,
      default: null
    },
    defaultAjax: { type: Object, required: false, default: () => ({}) },
    url: { type: String, required: true },
    name: { type: String, required: false, default: null },
    label: { type: String, required: false, default: null },
    trackBy: { type: String, required: false, default: 'id' },
    attributeLabel: { type: String, required: false, default: 'name' },
    required: { type: Boolean, required: false, default: false },
    errors: { type: [Object, Array], required: false, default: () => [] },
    fullModelResponse: { type: Boolean, required: false, default: false }
  },
  emits: ['update:modelValue', 'workSelect', 'selected:value'],
  data() {
    return { selected: this.defaultAjax ?? {} }
  },
  computed: {
    cErrors() {
      return fieldErrors(this.errors, this.name)
    },
    cDisplayedValue() {
      return this.selected?.[this.attributeLabel] ?? '-'
    }
  },
  watch: {
    defaultAjax(value) {
      this.selected = value ?? {}
    }
  },
  methods: {
    onSelect(value) {
      this.selected = value ?? {}
      if (!value) {
        this.$emit('update:modelValue', null)
        return
      }
      if (this.fullModelResponse) {
        this.$emit('update:modelValue', value)
      } else {
        this.$emit('update:modelValue', value[this.trackBy])
        this.$emit('selected:value', value[this.trackBy])
      }
      this.$emit('workSelect', value)
    }
  }
}
</script>
